import React, { useRef } from 'react'
import { List, ListItemButton, ListItemText, ListItem, Box, Tooltip } from '@mui/material'
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import ChatList from '../ChatList';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const status_translated = {
    'open': 'Conectada',
    'connecting': 'Conectando',
    'close': 'Desconectada'
}

const AccountListButton = ({ activeAccount, account, activate, activeChat, chatMessageId, chats = null, setActiveChat = () => { }, setGrandParent = () => { }}) => {

    const accountListRef = useRef()

    return (

        <>
            <Tooltip title={`Conta ${status_translated[account.status || 'close']}`}>
                <span>
                    <ListItemButton
                        onClick={activate}
                        className={`scout-list-item-account ${activeAccount?.id === account.id ? 'active' : account.status  || 'close'}`}
                        disableGutters
                        key={`account-item-main-id-${account.id}`}
                    >

                        <ListItem>
                            <ListItemText primary={
                                <Box className={`scout-title-accountheader ${activeAccount?.id === account.id ? 'active' : ''}`}>
                                    <span className='scout-title-subheader'>
                                        <span className='icon'>{<SupervisorAccountIcon />}</span>
                                        <span className='scout-wrapper-text'>
                                            <span className='scout-limit-text'>{account.name}</span>
                                            <span className='scout-limit-text'> {account.phone_number}</span>
                                        </span>
                                    </span>
                                    <span className='icon'>{activeAccount?.id === account.id ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}</span>
                                </Box>
                            } />
                        </ListItem>
                    </ListItemButton>
                </span>
            </Tooltip>
            {chats && <Box className='scout-chatlist'>
                <ChatList
                    listRef={accountListRef}
                    activeChat={activeChat}
                    chats={chats}
                    account={activeAccount}
                    chatMessageId={chatMessageId}
                    setGrandParent={setGrandParent}
                    setActiveChat={setActiveChat} />
            </Box>}
        </>
    )
}

const AccountList = ({ parent, setParent, onAccountSelect, onLoadMore }) => {

    const handleScroll = (event) => {
        if (!onLoadMore) return

        const element = event.currentTarget
        const distanceFromBottom = element.scrollHeight - (element.scrollTop + element.clientHeight)
        if (distanceFromBottom <= 160) {
            onLoadMore()
        }
    }

    return (
        <>
            <List disablePadding onScroll={handleScroll} className={`scout-list ${!parent.activeAccount ? 'overflow': ''}`}>
                {parent.activeAccount &&
                    <AccountListButton
                        activeAccount={parent.activeAccount}
                        account={parent.activeAccount}
                        activate={() => setParent({ activeAccount: null, activeChat: null, showCRMSidebar: false, showAnalyticsSidebar: false })}
                        activeChat={parent.activeChat}
                        chatMessageId={parent.chatMessageId}
                        chats={parent.chats}
                        setGrandParent={setParent}
                        setActiveChat={(chat) => setParent({ activeChat: chat, showCRMSidebar: false, showAnalyticsSidebar: true})}
                    />}
                { !parent.activeAccount && parent.accounts.filter(account => account.id !== parent.activeAccount?.id).map((account) => (
                    <AccountListButton
                        activeAccount={parent.activeAccount}
                        account={account}
                        activate={() => {
                            parent.accounts.forEach(acc => acc.priority = (acc === account ? 1 : (account.priority || 1) + 1));
                            if (onAccountSelect) {
                                onAccountSelect(account)
                            } else {
                                setParent({ activeAccount: account, activeChat: null })
                            }
                        }}
                    />
                ))
                }
                {!parent.activeAccount && parent.accountsLoadingMore ? (
                    <Box sx={{ p: 2, color: '#6d6d6d', fontSize: '.875rem' }}>Carregando...</Box>
                ) : null}
            </List >
        </>
    )
}

export default AccountList
